
import Vue, { PropType } from 'vue'
import { Input } from '../viewModels/input'
import { Quiz } from '../viewModels/quiz'

export default Vue.extend({
    name: 'AddDependentInputButton',
    props: {
        stepItems: {
            type: Array as PropType<{ type: typeof Input | typeof Quiz }[]>,
            required: true,
        },
    },
    computed: {
        items() {
            return this.stepItems.filter((item) => item.type instanceof Input)
        },
    },
})
